import { createAction, props } from '@ngrx/store';
import { TraceLoggingOverride } from './trace-logging-override.model';

export const getTraceLoggingOverride = createAction(
    '[TraceLoggingOverride/API] GET Trace Logging Overrides'
);

export const loadTraceLoggingOverrides = createAction(
    '[TraceLoggingOverride/API] Load Trace Logging Overrides',
    props<{ overrides: TraceLoggingOverride[] }>()
);

export const postTraceLoggingOverride = createAction(
    '[TraceLoggingOverride/API] POST Trace Logging Override',
    props<{
        customerId?: number;
        loginName?: string;
        minLogLevel: string;
        logTargets?: string;
        enabled: boolean;
        expiresUtc?: string;
        notes?: string;
    }>()
);

export const putTraceLoggingOverride = createAction(
    '[TraceLoggingOverride/API] PUT Trace Logging Override',
    props<{
        traceLoggingOverrideId: number;
        customerId?: number;
        loginName?: string;
        minLogLevel?: string;
        logTargets?: string;
        enabled?: boolean;
        expiresUtc?: string;
        notes?: string;
    }>()
);

export const clearTraceLoggingOverrides = createAction(
    '[TraceLoggingOverride/API] Clear Trace Logging Overrides'
);
